import { useEffect } from 'react';
import { Loading } from 'components/elements/Loading';
import EmptyGroupPlaceholder from 'components/widgets/Dashboard/EmptyGroupPlaceholder';
import Layout from 'components/widgets/Dashboard/Layout';
import CollectionDetails from 'components/widgets/Dashboard/PinnedProjects/CollectionDetails';
import CollectionList from 'components/widgets/Dashboard/PinnedProjects/CollectionList';
import { DEFAULT_COLLECTIONS } from 'components/widgets/Dashboard/PinnedProjects/constants';
import HiddenProjectDetails from 'components/widgets/Dashboard/PinnedProjects/HiddenProjectsDetails';
import StarredProjectsDetails from 'components/widgets/Dashboard/PinnedProjects/StarredProjectsDetails';
import WatchedProjectsDetails from 'components/widgets/Dashboard/PinnedProjects/WatchedProjectsDetails';
import { useCollections } from 'hooks/useCollections';
import { useSelectedLeadFilters } from 'hooks/useLeadTableFiltering';
import { useSelectedCollectionQuery } from 'state/queryParams';
import { FilterViewEnum } from 'types/FilterProjects';
import { trackPageView } from 'utils/analytics';
import {
  SavedProjectsPageViewSections,
  SavedProjectsPageViewSubSections,
} from 'utils/analytics/constants';

const SelectGroupDetails = () => {
  const [selectedGroup] = useSelectedCollectionQuery();

  useEffect(() => {
    trackPageView({
      sectionName: SavedProjectsPageViewSections.SAVED_PROJECTS,
      subSectionName: selectedGroup || SavedProjectsPageViewSubSections.HOME,
    });
  }, [selectedGroup]);

  if (!selectedGroup) {
    return (
      <EmptyGroupPlaceholder
        label="No lead lists yet – Star or Watch a project to start a lead list"
        imageAlt="No pinned projects"
        imageUrl="/dashboard-group-empty-state.png"
      />
    );
  }
  if (selectedGroup === DEFAULT_COLLECTIONS.ALL_HIDDEN.key) {
    return <HiddenProjectDetails />;
  }
  if (selectedGroup === DEFAULT_COLLECTIONS.ALL_WATCHED.key) {
    return <WatchedProjectsDetails />;
  }
  if (selectedGroup === DEFAULT_COLLECTIONS.ALL_STARRED.key) {
    return <StarredProjectsDetails />;
  }

  return (
    <Loading>
      <CollectionDetails />
    </Loading>
  );
};

const PinnedProjects = () => {
  const { getCollectionsList } = useCollections();
  const { data: collectionList } = getCollectionsList;
  const { setSelectedLeadFilters: setActiveTabs } = useSelectedLeadFilters();
  const [selectedGroup, setSelectedGroup] = useSelectedCollectionQuery();

  useEffect(() => {
    setActiveTabs([FilterViewEnum.WATCH, FilterViewEnum.STAR]);
  }, []);

  // Auto-select first collection if collections exist and none is selected
  useEffect(() => {
    if (collectionList && collectionList.length > 0 && !selectedGroup) {
      setSelectedGroup(String(collectionList[0].id));
    }
  }, [collectionList, selectedGroup, setSelectedGroup]);

  return (
    <Layout
      menuContent={<CollectionList groups={collectionList || []} />}
      detailContent={<SelectGroupDetails />}
    />
  );
};

export default PinnedProjects;
